import { Link } from "react-router-dom";
import { CurrencyIcon } from "../../../../Components/Atoms/CurrencyIcon";
import { StablesBalanceValueSkeleton } from "../../../../Components/Molecules/DashboardSkeleton";
import { formatBrl, formatCurrencyWithSymbol } from "../constants";

const MetaBalance = ({ label, value, currencyId, warn = false }) => (
  <div className="min-w-0">
    <p className="text-[10px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
      {label}
    </p>
    <p
      className={`mt-0.5 break-words text-sm font-semibold leading-snug ${
        warn ? "text-amber-700 dark:text-amber-400" : "text-brand-dark"
      }`}
    >
      {formatCurrencyWithSymbol(value, currencyId)}
    </p>
  </div>
);

const CurrencyBalanceCardContent = ({ currency, loadingRates = false }) => {
  const balance = Number(currency.balance ?? 0);
  const blockedBalance = Number(currency.blockedBalance ?? 0);
  const futureBalance = Number(currency.futureBalance ?? 0);
  const limit = Number(currency.limit ?? 0);
  const equivalentBrl = balance * Number(currency.rateToBrl || 0);
  const hasLimit = limit > 0;

  return (
    <>
      <div className="flex min-w-0 items-center gap-2.5">
        <div className="summary-card-icon">
          <CurrencyIcon asset={currency.id} size={18} />
        </div>
        <p className="truncate text-sm font-semibold text-brand-dark">
          {currency.label}
        </p>
      </div>

      <div className="mt-3.5 min-w-0">
        <p className="text-[10px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
          Saldo disponível
        </p>
        {loadingRates ? (
          <div className="mt-1.5">
            <StablesBalanceValueSkeleton />
          </div>
        ) : (
          <>
            <p className="mt-1 break-words text-2xl font-bold leading-tight text-brand-dark">
              {formatCurrencyWithSymbol(balance, currency.id)}
            </p>
            {currency.id !== "brl" && (
              <p className="mt-1 text-xs text-gray-400">
                ≈ {formatBrl(equivalentBrl)}
              </p>
            )}
          </>
        )}
      </div>

      <div className="mt-3.5 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-gray-100 pt-3 dark:border-brand-dark-border">
        {loadingRates ? (
          <>
            <StablesBalanceValueSkeleton />
            <StablesBalanceValueSkeleton />
          </>
        ) : (
          <>
            <MetaBalance
              label="Saldo bloqueado"
              value={blockedBalance}
              currencyId={currency.id}
              warn={blockedBalance > 0}
            />
            <MetaBalance
              label="Saldo futuro"
              value={futureBalance}
              currencyId={currency.id}
            />
          </>
        )}
      </div>

      {hasLimit ? (
        <div className="balance-card-footer mt-auto border-t border-gray-100 pt-3 text-xs text-gray-400 dark:border-brand-dark-border">
          Limite: {formatCurrencyWithSymbol(limit, currency.id)}
        </div>
      ) : (
        <div className="balance-card-footer mt-auto" />
      )}
    </>
  );
};

export const CurrencyBalanceCard = ({
  currency,
  variant = "hub",
  loadingRates = false,
}) => {
  if (variant === "detail") {
    return (
      <div className="summary-card balance-card mb-4 w-full !p-4 sm:!p-5">
        <CurrencyBalanceCardContent currency={currency} loadingRates={loadingRates} />
      </div>
    );
  }

  return (
    <Link
      to={`/conta-internacional/${currency.id}`}
      className="summary-card balance-card link-no-zoom block no-underline !p-4"
    >
      <CurrencyBalanceCardContent currency={currency} loadingRates={loadingRates} />
    </Link>
  );
};
